import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames"
import { faCheck } from "@fortawesome/pro-regular-svg-icons"

import Icon from "../../../layout/icon"

import {
  careServiceTypeContainer,
  careServiceTypeListContainer,
  icon,
} from "./styles.module.scss"
import { InlineText } from "../../../Typography/Typography"

const careServiceTypeWeights = {
  Residential: 10,
  Dementia: 20,
  Nursing: 30,
  Palliative: 40,
}

const careServiceTypes = Object.keys(careServiceTypeWeights)

const byWeight = (a, b) =>
  careServiceTypeWeights[a] < careServiceTypeWeights[b] ? -1 : 1

function CareServiceType({ label }) {
  return (
    <div className={classNames(careServiceTypeContainer)}>
      <div className={classNames(icon)}>
        <Icon icon={faCheck} />
      </div>
      <InlineText semibold>{label}</InlineText>
    </div>
  )
}

CareServiceType.propTypes = {
  label: PropTypes.oneOf(careServiceTypes).isRequired,
}

const toCareServiceTypeLabel = (careServiceType) => (
  <CareServiceType key={careServiceType} label={careServiceType} />
)

export default function CareServiceTypeList({
  enabledCareServiceTypes,
  className,
}) {
  return (
    <div className={classNames(className, careServiceTypeListContainer)}>
      {enabledCareServiceTypes.sort(byWeight).map(toCareServiceTypeLabel)}
    </div>
  )
}

CareServiceTypeList.propTypes = {
  enabledCareServiceTypes: PropTypes.arrayOf(PropTypes.oneOf(careServiceTypes))
    .isRequired,
  className: PropTypes.string,
}

CareServiceTypeList.defaultProps = {
  className: undefined,
}
